import React, { useMemo } from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing'
import NonameCredentialsForm from './NonameCredentialsForm'
import NonameMappingForm from './NonameMappingForm'
import { columnRenderArrayData } from 'utils/tableUtils'

function NonameConfigListing(props) {

    const extraColumns = useMemo(() => [
        {
            title: "Application Name",
            dataIndex: "applicationNames",
            render: columnRenderArrayData,
            width: 200
        },
        {
            title: "Hosts",
            dataIndex: "hosts",
            render: columnRenderArrayData,
            width: 200
        }
    ], []);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={NonameMappingForm}
            CredentialsForm={NonameCredentialsForm}
            extraColumns={extraColumns}
        />
    )
}

export default NonameConfigListing
